<template>
  <div class="calculation">
    <div class="calculation-dec">日期计算器，日期计算器帮助您快速计算出N天前后的具体日期以及计算日期差</div>
    <div class="calculation-main">
      <div class="dayNm">
        <div class="main-title">相隔天数计算</div>
        <div class="dayNm-input clearfix">
          <ul>
            <li>
              <span>开始时间</span>
              <el-select v-model="yearValue01" size="small" @change="getDay" placeholder="请选择">
                <el-option
                  v-for="item in year"
                  :key="item"
                  :label="item + '年'"
                  :value="item">
                </el-option>
              </el-select>
              <el-select v-model="monthvalue01" size="small" @change="getDay" placeholder="请选择">
                <el-option
                  v-for="item in month"
                  :key="item"
                  :label="item + '月'"
                  :value="item">
                </el-option>
              </el-select>
              <el-select v-model="dayValue01" size="small" placeholder="请选择">
                <template v-for="item in day">
                  <el-option
                    v-if="item <= dayNum01"
                    :key="item"
                    :label="item + '日'"
                    :value="item">
                  </el-option>
                </template>
              </el-select>
            </li>
            <li>
              <span>结束时间</span>
              <el-select v-model="yearValue02" size="small" @change="getDay" placeholder="请选择">
                <el-option
                  v-for="item in year"
                  :key="item"
                  :label="item+ '年'"
                  :value="item">
                </el-option>
              </el-select>
              <el-select v-model="monthvalue02" size="small" @change="getDay" placeholder="请选择">
                <el-option
                  v-for="item in month"
                  :key="item"
                  :label="item + '月'"
                  :value="item">
                </el-option>
              </el-select>
              <el-select v-model="dayValue02" size="small" placeholder="请选择">
                <template v-for="item in day">
                  <el-option
                    v-if="item <= dayNum02"
                    :key="item"
                    :label="item + '日'"
                    :value="item">
                  </el-option>
                </template>
              </el-select>
            </li>
          </ul>
          <ul class="daynm-btn">
            <el-button type="primary" @click="save">计算</el-button>
          </ul>
        </div>
        <div class="dayNm-result">两个日期相差：<span>{{ differ }}天</span></div>
      </div>
      
      <div class="dayNm">
        <div class="main-title">相隔天数计算</div>
        <div class="dayNm-input clearfix">
          <ul>
            <li>
              <span>开始时间</span>
              <el-select v-model="yearValue03" size="small" @change="getDay" placeholder="请选择">
                <el-option
                  v-for="item in year"
                  :key="item"
                  :label="item + '年'"
                  :value="item">
                </el-option>
              </el-select>
              <el-select v-model="monthvalue03" size="small" @change="getDay" placeholder="请选择">
                <el-option
                  v-for="item in month"
                  :key="item"
                  :label="item + '月'"
                  :value="item">
                </el-option>
              </el-select>
              <el-select v-model="dayValue03" size="small" placeholder="请选择">
                <template v-for="item in day">
                  <el-option
                    v-if="item <= dayNum03"
                    :key="item"
                    :label="item + '日'"
                    :value="item">
                  </el-option>
                </template>
              </el-select>
            </li>
            <li>
              <span>结束时间</span>
              <el-input v-model.number="dayInput" type="text"></el-input>
              <span>天（填负数则向前推算）</span>
            </li>
          </ul>
          <ul class="daynm-btn" >
            <el-button type="primary" @click="calculationSave">推算</el-button>
          </ul>
        </div>
        <div class="dayNm-result"><span>{{ calculationDay }}</span></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from 'element-plus'
export default {
  data () {
    return {
      year: [1900, 1901, 1902, 1903, 1904, 1905, 1906, 1907, 1908, 1909, 1910, 1911, 1912, 1913, 1914, 1915, 1916, 1917, 1918, 1919, 1920, 1921, 1922, 1923,
      1924, 1925, 1926, 1927, 1928, 1929, 1930, 1931, 1932, 1933, 1934, 1935, 1936, 1937, 1938, 1939, 1940, 1941, 1942, 1943, 1944, 1945, 1946, 1947, 1948,
      1949, 1950, 1951, 1952, 1953, 1954, 1955, 1956, 1957, 1958, 1959, 1960, 1961, 1962, 1963, 1964, 1965, 1966, 1967, 1968, 1969, 1970, 1971, 1972, 1973, 1974, 1975,
      1976, 1977, 1978, 1979, 1980, 1981, 1982, 1983, 1984, 1985, 1986, 1987, 1988, 1989, 1990, 1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999, 2000,
      2001, 2002, 2003, 2004, 2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025,
      2026, 2027, 2028, 2029, 2030, 2031, 2032, 2033, 2034, 2035, 2036, 2037, 2038, 2039, 2040, 2041, 2042, 2043, 2044, 2045, 2046, 2047, 2048, 2049, 2050,
      2051, 2052, 2053, 2054, 2055, 2056, 2057, 2058, 2059, 2060, 2061, 2062, 2063, 2064, 2065, 2066, 2067, 2068, 2069, 2070, 2071, 2072, 2073, 2074, 2075,
      2076, 2077, 2078, 2079, 2080, 2081, 2082, 2083, 2084, 2085, 2086, 2087, 2088, 2089, 2090, 2091, 2092, 2093, 2094, 2095, 2096, 2097, 2098, 2099, 2100],
      yearValue01: '',
      yearValue02: '',
      yearValue03: '',
      monthvalue01: '',
      monthvalue02: '',
      monthvalue03: '',
      month: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      dayValue01: '',
      dayValue02: '',
      dayValue03: '',
      day: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31],
      dayNum01: 31,
      dayNum02: 31,
      dayNum03: 31,
      differ: 0,
      calculationDay: '',
      dayInput: ''
    }
  },
  created () {
    let date = new Date()
    this.yearValue01 = this.yearValue02 = this.yearValue03 = date.getFullYear()
    this.monthvalue01 = this.monthvalue02 = this.monthvalue03 = date.getMonth() + 1
    this.dayValue01 = this.dayValue02 = this.dayValue03 = date.getDate()
    this.calculationDay = this.yearValue03 + '年' + this.monthvalue03 + '月' + this.dayValue03 + '日'
    this.getDay()
  },
  methods: {
    // 获取当前月天数
    getDay () {
      this.dayNum01 = new Date(this.yearValue01, this.monthvalue01, 0).getDate()
      this.dayNum02 = new Date(this.yearValue02, this.monthvalue02, 0).getDate()
      this.dayNum03 = new Date(this.yearValue03, this.monthvalue03, 0).getDate()
    },
    // 计算相差天数
    save () {
      let date01 = new Date(this.yearValue01 + '-' + this.monthvalue01 + '-' + this.dayValue01).getTime()
      let date02 = new Date(this.yearValue02 + '-' + this.monthvalue02 + '-' + this.dayValue02).getTime()
      if (date01 > date02) {
        this.differ = parseInt((date01 - date02) / 1000 / 60 / 60 / 24)
      } else {
        this.differ = parseInt((date02 - date01) / 1000 / 60 / 60 / 24)
      }
    },
    // 推算相差天数
    calculationSave () {
      if (this.dayInput !== '' && this.dayInput === this.dayInput + '') {
        ElMessage.error('请输入数字');
        return
      }
      let date01 = new Date(this.yearValue03 + '-' + this.monthvalue03 + '-' + this.dayValue03).getTime()
      let date02 =this.dayInput == '' ? 0 : this.dayInput * 24 * 60 * 60 * 1000
      const date = new Date(date01 + date02)
      this.calculationDay = date.getFullYear() + '年' + (date.getMonth() + 1) + '月' + date.getDate() + '日'
    }
  }
}
</script>

<style lang="stylus" scope>
.calculation
  padding 0 20px
  .calculation-dec
    font-size 16px
    text-align center
  .calculation-main
    width 800px
    margin 20px auto 
    padding 20px
    border 1px solid #ddd

.dayNm
  margin-bottom 20px
  .main-title
    font-size 18px
    line-height 20px
    color #1890ff
    margin-bottom 10px
  .dayNm-input
    padding 0 138px
    ul
      float left
      li
        margin-bottom 20px
        text-align center
        .el-select
          width 100px
          margin-left 10px
        > .el-input
          width 134px
          margin 0 10px  
    .daynm-btn
      margin-left 30px
      margin-top 20px
  .dayNm-result
    line-height 60px
    width 300px
    margin 0 auto
    text-align center
    border-radius 4px
    background-color #b8dcf5
    span
      color #1890ff
</style>